import WriteToLog from "./WriteToLog";   

/**
 * Calculate Weight > 85th percentile for age normal
 * @param {*} weight of the patient
 * @param {*} gender
 * @param {*} age_exact_months
 * @param {*} age_number Patient's age in years
 * @returns 
 */
async function calculateOverWeight(weight, gender, age_exact_months) {
  let overweightRisk = "none";
  var Weightmax = "";

  try {
    if (age_exact_months <= 25) {
      if (age_exact_months >= 0 && age_exact_months < 1) { // 0-24 months WHO Weight
        if (gender === 'F') {
          Weightmax = 3.7;
        } else if ( gender === 'M') {
          Weightmax = 3.9;
        }
      } else if (age_exact_months >= 1 && age_exact_months < 2) {
        if (gender === 'F') {
          Weightmax = 4.8;
        } else if ( gender === 'M') {
          Weightmax = 5.1;
        }    
      } else if (age_exact_months >= 2 && age_exact_months < 3) {
        if (gender === 'F') {
          Weightmax = 5.9;
        } else if ( gender === 'M') {
          Weightmax = 6.3;
        }
      } else if (age_exact_months >= 3 && age_exact_months < 4) {
        if (gender === 'F') {
          Weightmax = 6.7;
        } else if ( gender === 'M') {
          Weightmax = 7.2;
        }    
      } else if (age_exact_months >= 4 && age_exact_months < 5) {
        if (gender === 'F') {
          Weightmax = 7.3;
        } else if ( gender === 'M') {
          Weightmax = 7.9;
        }
      } else if (age_exact_months >= 5 && age_exact_months < 6) {
        if (gender === 'F') {
          Weightmax = 7.8;
        } else if ( gender === 'M') {
          Weightmax = 8.4;
        } 
      } else if (age_exact_months >= 6 && age_exact_months < 7) {
        if (gender === 'F') {
          Weightmax = 8.3;
        } else if ( gender === 'M') {
          Weightmax = 8.9;
        } 
      } else if (age_exact_months >= 7 && age_exact_months < 8) {
        if (gender === 'F') {
          Weightmax = 8.7;
        } else if ( gender === 'M') {
          Weightmax = 9.3;
        }
      } else if (age_exact_months >= 8 && age_exact_months < 9) {
        if (gender === 'F') {
          Weightmax = 9;
        } else if ( gender === 'M') {
          Weightmax = 9.6;
        } 
      } else if (age_exact_months >= 9 && age_exact_months < 10) {
        if (gender === 'F') {
          Weightmax = 9.3;
        } else if ( gender === 'M') {
          Weightmax = 10;
        } 
      } else if (age_exact_months >= 10 && age_exact_months < 11) {
        if (gender === 'F') {
          Weightmax = 9.6;
        } else if ( gender === 'M') {
          Weightmax = 10.3;
        } 
      } else if (age_exact_months >= 11 && age_exact_months < 12) {
        if (gender === 'F') {
          Weightmax = 9.9;
        } else if ( gender === 'M') {
          Weightmax = 10.5;
        } 
      } else if (age_exact_months >= 12 && age_exact_months < 13) {
        if (gender === 'F') {
          Weightmax = 10.2;
        } else if ( gender === 'M') {
          Weightmax = 10.8;
        } 
      } else if (age_exact_months >= 13 && age_exact_months < 14) {
        if (gender === 'F') {
          Weightmax = 10.4;
        } else if ( gender === 'M') {
          Weightmax = 11.1;
        } 
      } else if (age_exact_months >= 14 && age_exact_months < 15) {
        if (gender === 'F') {
          Weightmax = 10.7;
        } else if ( gender === 'M') {
          Weightmax = 11.3;
        } 
      } else if (age_exact_months >= 15 && age_exact_months < 16) {
        if (gender === 'F') {
          Weightmax = 10.9;
        } else if ( gender === 'M') {
          Weightmax = 11.6;
        } 
      } else if (age_exact_months >= 16 && age_exact_months < 17) {
        if (gender === 'F') {
          Weightmax = 11.2;
        } else if ( gender === 'M') {
          Weightmax = 11.8;
        } 
      } else if (age_exact_months >= 17 && age_exact_months < 18) {
        if (gender === 'F') {
          Weightmax = 11.4;
        } else if ( gender === 'M') {
          Weightmax = 12;
        } 
      } else if (age_exact_months >= 18 && age_exact_months < 19) {
        if (gender === 'F') {
          Weightmax = 11.6;
        } else if ( gender === 'M') {
          Weightmax = 12.3;
        } 
      } else if (age_exact_months >= 19 && age_exact_months < 20) {
        if (gender === 'F') {
          Weightmax = 11.9;
        } else if ( gender === 'M') {
          Weightmax = 12.5;
        } 
      } else if (age_exact_months >= 20 && age_exact_months < 21) {
        if (gender === 'F') {
          Weightmax = 12.1;
        } else if ( gender === 'M') {
          Weightmax = 12.7;
        } 
      } else if (age_exact_months >= 21 && age_exact_months < 22) {
        if (gender === 'F') {
          Weightmax = 12.4;
        } else if ( gender === 'M') {
          Weightmax = 13;
        } 
      } else if (age_exact_months >= 22 && age_exact_months < 23) {
        if (gender === 'F') {
          Weightmax = 12.6;
        } else if ( gender === 'M') {
          Weightmax = 13.2;
        } 
      } else if (age_exact_months >= 23 && age_exact_months < 24) {
        if (gender === 'F') {
          Weightmax = 12.8;
        } else if ( gender === 'M') {
          Weightmax = 13.4;
        } 
      } else if (age_exact_months >= 24 && age_exact_months < 25) {
        if (gender === 'F') {
          Weightmax = 13.1;
        } else if ( gender === 'M') {
          Weightmax = 13.7;
        } 
      } else if (age_exact_months === 25) { // 2y+ CDC Weight: 25.0 months -> use 24.5 value 
        if (gender === 'F') {
          Weightmax = 13.63503;
        } else if ( gender === 'M') {
          Weightmax = 14.27214;
        } 
      }
    }
    if (age_exact_months > 25 && age_exact_months <= 50) {
      if (age_exact_months > 25 && age_exact_months <= 26) { // 25.01 months -> use 25.5 value
        if (gender === 'F') {
          Weightmax = 13.82551;
        } else if ( gender === 'M') {
          Weightmax = 14.43223;
        } 
      } else if (age_exact_months > 26 && age_exact_months <= 27) {
        if (gender === 'F') {
          Weightmax = 14.01420;
        } else if ( gender === 'M') {
          Weightmax = 14.59099;
        } 
      } else if (age_exact_months > 27 && age_exact_months <= 28) {
        if (gender === 'F') {
          Weightmax = 14.20177;
        } else if ( gender === 'M') {
          Weightmax = 14.74926;
        } 
      } else if (age_exact_months > 28 && age_exact_months <= 29) {
        if (gender === 'F') {
          Weightmax = 14.38882;
        } else if ( gender === 'M') {
          Weightmax = 14.90778;
        } 
      } else if (age_exact_months > 29 && age_exact_months <= 30) {
        if (gender === 'F') {
          Weightmax = 14.57585;
        } else if ( gender === 'M') {
          Weightmax = 15.06718;
        } 
      } else if (age_exact_months > 30 && age_exact_months <= 31) {
        if (gender === 'F') {
          Weightmax = 14.76332;
        } else if ( gender === 'M') {
          Weightmax = 15.22801;
        } 
      } else if (age_exact_months > 31 && age_exact_months <= 32) {
        if (gender === 'F') {
          Weightmax = 14.95159;
        } else if ( gender === 'M') {
          Weightmax = 15.39071;
        } 
      } else if (age_exact_months > 32 && age_exact_months <= 33) {
        if (gender === 'F') {
          Weightmax = 15.14098;
        } else if ( gender === 'M') {
          Weightmax = 15.55568;
        } 
      } else if (age_exact_months > 33 && age_exact_months <= 34) {
        if (gender === 'F') {
          Weightmax = 15.33175;
        } else if ( gender === 'M') {
          Weightmax = 15.72322;
        } 
      } else if (age_exact_months > 34 && age_exact_months <= 35) {
        if (gender === 'F') {
          Weightmax = 15.52412;
        } else if ( gender === 'M') {
          Weightmax = 15.89360;
        } 
      } else if (age_exact_months > 35 && age_exact_months <= 36) {
        if (gender === 'F') {
          Weightmax = 15.71826;
        } else if ( gender === 'M') {
          Weightmax = 16.06700;
        } 
      } else if (age_exact_months > 36 && age_exact_months <= 37) {
        if (gender === 'F') {
          Weightmax = 15.91429;
        } else if ( gender === 'M') {
          Weightmax = 16.24358;
        } 
      } else if (age_exact_months > 37 && age_exact_months <= 38) {
        if (gender === 'F') {
          Weightmax = 16.11231;
        } else if ( gender === 'M') {
          Weightmax = 16.42344;
        } 
      } else if (age_exact_months > 38 && age_exact_months <= 39) {
        if (gender === 'F') {
          Weightmax = 16.31240;
        } else if ( gender === 'M') {
          Weightmax = 16.60665;
        } 
      } else if (age_exact_months > 39 && age_exact_months <= 40) {
        if (gender === 'F') {
          Weightmax = 16.51458;
        } else if ( gender === 'M') {
          Weightmax = 16.79324;
        } 
      } else if (age_exact_months > 40 && age_exact_months <= 41) {
        if (gender === 'F') {
          Weightmax = 16.71889;
        } else if ( gender === 'M') {
          Weightmax = 16.98322;
        } 
      } else if (age_exact_months > 41 && age_exact_months <= 42) {
        if (gender === 'F') {
          Weightmax = 16.92531;
        } else if ( gender === 'M') {
          Weightmax = 17.17655;
        } 
      } else if (age_exact_months > 42 && age_exact_months <= 43) {
        if (gender === 'F') {
          Weightmax = 17.13383;
        } else if ( gender === 'M') {
          Weightmax = 17.37320;
        } 
      } else if (age_exact_months > 43 && age_exact_months <= 44) {
        if (gender === 'F') {
          Weightmax = 17.34442;
        } else if ( gender === 'M') {
          Weightmax = 17.57308;
        } 
      } else if (age_exact_months > 44 && age_exact_months <= 45) {
        if (gender === 'F') {
          Weightmax = 17.55705;
        } else if ( gender === 'M') {
          Weightmax = 17.77613;
        } 
      } else if (age_exact_months > 45 && age_exact_months <= 46) {
        if (gender === 'F') {
          Weightmax = 17.77165;
        } else if ( gender === 'M') {
          Weightmax = 17.98225;
        } 
      } else if (age_exact_months > 46 && age_exact_months <= 47) {
        if (gender === 'F') {
          Weightmax = 17.98819;
        } else if ( gender === 'M') {
          Weightmax = 18.19131;
        } 
      } else if (age_exact_months > 47 && age_exact_months <= 48) {
        if (gender === 'F') {
          Weightmax = 18.20660;
        } else if ( gender === 'M') {
          Weightmax = 18.40322;
        } 
      } else if (age_exact_months > 48 && age_exact_months <= 49) {
        if (gender === 'F') {
          Weightmax = 18.42683;
        } else if ( gender === 'M') {
          Weightmax = 18.61785;
        } 
      } else if (age_exact_months > 49 && age_exact_months <= 50) {
        if (gender === 'F') {
          Weightmax = 18.64882;
        } else if ( gender === 'M') {
          Weightmax = 18.83506;
        } 
      }
    }
    if (age_exact_months > 50 && age_exact_months <= 100) {
      if (age_exact_months > 50 && age_exact_months <= 51) {
        if (gender === 'F') {
          Weightmax = 18.87251;
        } else if ( gender === 'M') {
          Weightmax = 19.05474;
        } 
      } else if (age_exact_months > 51 && age_exact_months <= 52) {
        if (gender === 'F') {
          Weightmax = 19.09785;
        } else if ( gender === 'M') {
          Weightmax = 19.27675;
        } 
      } else if (age_exact_months > 52 && age_exact_months <= 53) {
        if (gender === 'F') {
          Weightmax = 19.32478;
        } else if ( gender === 'M') {
          Weightmax = 19.50096;
        } 
      } else if (age_exact_months > 53 && age_exact_months <= 54) {
        if (gender === 'F') {
          Weightmax = 19.55328;
        } else if ( gender === 'M') {
          Weightmax = 19.72726;
        } 
      } else if (age_exact_months > 54 && age_exact_months <= 55) {
        if (gender === 'F') {
          Weightmax = 19.78329;
        } else if ( gender === 'M') {
          Weightmax = 19.95551;
        } 
      } else if (age_exact_months > 55 && age_exact_months <= 56) {
        if (gender === 'F') {
          Weightmax = 20.01479;
        } else if ( gender === 'M') {
          Weightmax = 20.18561;
        } 
      } else if (age_exact_months > 56 && age_exact_months <= 57) {
        if (gender === 'F') {
          Weightmax = 20.24776;
        } else if ( gender === 'M') {
          Weightmax = 20.41743;
        } 
      } else if (age_exact_months > 57 && age_exact_months <= 58) {
        if (gender === 'F') {
          Weightmax = 20.48218;
        } else if ( gender === 'M') {
          Weightmax = 20.65089;
        } 
      } else if (age_exact_months > 58 && age_exact_months <= 59) {
        if (gender === 'F') {
          Weightmax = 20.71804;
        } else if ( gender === 'M') {
          Weightmax = 20.88588;
        } 
      } else if (age_exact_months > 59 && age_exact_months <= 60) {
        if (gender === 'F') {
          Weightmax = 20.95535;
        } else if ( gender === 'M') {
          Weightmax = 21.12232;
        } 
      } else if (age_exact_months > 60 && age_exact_months <= 61) {
        if (gender === 'F') {
          Weightmax = 21.19412;
        } else if ( gender === 'M') {
          Weightmax = 21.36013;
        } 
      } else if (age_exact_months > 61 && age_exact_months <= 62) {
        if (gender === 'F') {
          Weightmax = 21.43437;
        } else if ( gender === 'M') {
          Weightmax = 21.59923;
        } 
      } else if (age_exact_months > 62 && age_exact_months <= 63) {
        if (gender === 'F') {
          Weightmax = 21.67612;
        } else if ( gender === 'M') {
          Weightmax = 21.83957;
        } 
      } else if (age_exact_months > 63 && age_exact_months <= 64) {
        if (gender === 'F') {
          Weightmax = 21.91942;
        } else if ( gender === 'M') {
          Weightmax = 22.08110;
        } 
      } else if (age_exact_months > 64 && age_exact_months <= 65) {
        if (gender === 'F') {
          Weightmax = 22.16431;
        } else if ( gender === 'M') {
          Weightmax = 22.32377;
        } 
      } else if (age_exact_months > 65 && age_exact_months <= 66) {
        if (gender === 'F') {
          Weightmax = 22.41086;
        } else if ( gender === 'M') {
          Weightmax = 22.56756;
        } 
      } else if (age_exact_months > 66 && age_exact_months <= 67) {
        if (gender === 'F') {
          Weightmax = 22.65911;
        } else if ( gender === 'M') {
          Weightmax = 22.81244;
        } 
      } else if (age_exact_months > 67 && age_exact_months <= 68) {
        if (gender === 'F') {
          Weightmax = 22.90915;
        } else if ( gender === 'M') {
          Weightmax = 23.05841;
        } 
      } else if (age_exact_months > 68 && age_exact_months <= 69) {
        if (gender === 'F') {
          Weightmax = 23.16106;
        } else if ( gender === 'M') {
          Weightmax = 23.30545;
        } 
      } else if (age_exact_months > 69 && age_exact_months <= 70) {
        if (gender === 'F') {
          Weightmax = 23.41492;
        } else if ( gender === 'M') {
          Weightmax = 23.55358;
        } 
      } else if (age_exact_months > 70 && age_exact_months <= 71) {
        if (gender === 'F') {
          Weightmax = 23.67083;
        } else if ( gender === 'M') {
          Weightmax = 23.80282;
        } 
      } else if (age_exact_months > 71 && age_exact_months <= 72) {
        if (gender === 'F') {
          Weightmax = 23.92888;
        } else if ( gender === 'M') {
          Weightmax = 24.05318;
        } 
      } else if (age_exact_months > 72 && age_exact_months <= 73) {
        if (gender === 'F') {
          Weightmax = 24.18919; 
        } else if ( gender === 'M') {
          Weightmax = 24.30472;
        } 
      } else if (age_exact_months > 73 && age_exact_months <= 74) {
        if (gender === 'F') {
          Weightmax = 24.45186;
        } else if ( gender === 'M') {
          Weightmax = 24.55745;
        } 
      } else if (age_exact_months > 74 && age_exact_months <= 75) {
        if (gender === 'F') {
          Weightmax = 24.71702;
        } else if ( gender === 'M') {
          Weightmax = 24.81145;
        } 
      } else if (age_exact_months > 75 && age_exact_months <= 76) {
        if (gender === 'F') {
          Weightmax = 24.98477;
        } else if ( gender === 'M') {
          Weightmax = 25.06677;
        } 
      } else if (age_exact_months > 76 && age_exact_months <= 77) {
        if (gender === 'F') {
          Weightmax = 25.25526;
        } else if ( gender === 'M') {
          Weightmax = 25.32348;
        } 
      } else if (age_exact_months > 77 && age_exact_months <= 78) {
        if (gender === 'F') {
          Weightmax = 25.52859;
        } else if ( gender === 'M') {
          Weightmax = 25.58165;
        } 
      } else if (age_exact_months > 78 && age_exact_months <= 79) {
        if (gender === 'F') {
          Weightmax = 25.80491;
        } else if ( gender === 'M') {
          Weightmax = 25.84136;
        } 
      } else if (age_exact_months > 79 && age_exact_months <= 80) {
        if (gender === 'F') {
          Weightmax = 26.08434;
        } else if ( gender === 'M') {
          Weightmax = 26.10271;
        } 
      } else if (age_exact_months > 80 && age_exact_months <= 81) {
        if (gender === 'F') {
          Weightmax = 26.36701;
        } else if ( gender === 'M') {
          Weightmax = 26.36579;
        } 
      } else if (age_exact_months > 81 && age_exact_months <= 82) {
        if (gender === 'F') {
          Weightmax = 26.65305;
        } else if ( gender === 'M') {
          Weightmax = 26.63069;
        } 
      } else if (age_exact_months > 82 && age_exact_months <= 83) {
        if (gender === 'F') {
          Weightmax = 26.94261;
        } else if ( gender === 'M') {
          Weightmax = 26.89752;
        } 
      } else if (age_exact_months > 83 && age_exact_months <= 84) {
        if (gender === 'F') {
          Weightmax = 27.23580;
        } else if ( gender === 'M') {
          Weightmax = 27.16640;
        } 
      } else if (age_exact_months > 84 && age_exact_months <= 85) {
        if (gender === 'F') {
          Weightmax = 27.53276;
        } else if ( gender === 'M') {
          Weightmax = 27.43744;
        } 
      } else if (age_exact_months > 85 && age_exact_months <= 86) {
        if (gender === 'F') {
          Weightmax = 27.83361;
        } else if ( gender === 'M') {
          Weightmax = 27.71075;
        } 
      } else if (age_exact_months > 86 && age_exact_months <= 87) {
        if (gender === 'F') {
          Weightmax = 28.13848;
        } else if ( gender === 'M') {
          Weightmax = 27.98646;
        } 
      } else if (age_exact_months > 87 && age_exact_months <= 88) {
        if (gender === 'F') {
          Weightmax = 28.44748;
        } else if ( gender === 'M') {
          Weightmax = 28.26469;
        } 
      } else if (age_exact_months > 88 && age_exact_months <= 89) {
        if (gender === 'F') {
          Weightmax = 28.76074;
        } else if ( gender === 'M') {
          Weightmax = 28.54556;
        } 
      } else if (age_exact_months > 89 && age_exact_months <= 90) {
        if (gender === 'F') {
          Weightmax = 29.07835;
        } else if ( gender === 'M') {
          Weightmax = 28.82921;
        } 
      } else if (age_exact_months > 90 && age_exact_months <= 91) {
        if (gender === 'F') {
          Weightmax = 29.40044;
        } else if ( gender === 'M') {
          Weightmax = 29.11575;
        } 
      } else if (age_exact_months > 91 && age_exact_months <= 92) {
        if (gender === 'F') {
          Weightmax = 29.72710;
        } else if ( gender === 'M') {
          Weightmax = 29.40532;
        } 
      } else if (age_exact_months > 92 && age_exact_months <= 93) {
        if (gender === 'F') {
          Weightmax = 30.05841;
        } else if ( gender === 'M') {
          Weightmax = 29.69805;
        } 
      } else if (age_exact_months > 93 && age_exact_months <= 94) {
        if (gender === 'F') {
          Weightmax = 30.39447;
        } else if ( gender === 'M') {
          Weightmax = 29.99406;
        } 
      } else if (age_exact_months > 94 && age_exact_months <= 95) {
        if (gender === 'F') {
          Weightmax = 30.73536;
        } else if ( gender === 'M') {
          Weightmax = 30.29347;
        } 
      } else if (age_exact_months > 95 && age_exact_months <= 96) {
        if (gender === 'F') {
          Weightmax = 31.08114;
        } else if ( gender === 'M') {
          Weightmax = 30.59641;
        } 
      } else if (age_exact_months > 96 && age_exact_months <= 97) {
        if (gender === 'F') {
          Weightmax = 31.43188;
        } else if ( gender === 'M') {
          Weightmax = 30.90299;
        } 
      } else if (age_exact_months > 97 && age_exact_months <= 98) {
        if (gender === 'F') {
          Weightmax = 31.78763;
        } else if ( gender === 'M') {
          Weightmax = 31.21334;
        } 
      } else if (age_exact_months > 98 && age_exact_months <= 99) {
        if (gender === 'F') {
          Weightmax = 32.14844;
        } else if ( gender === 'M') {
          Weightmax = 31.52756;
        } 
      } else if (age_exact_months > 99 && age_exact_months <= 100) {
        if (gender === 'F') {
          Weightmax = 32.51432;
        } else if ( gender === 'M') {
          Weightmax = 31.84576;
        } 
      } 
    }
    if (age_exact_months > 100 && age_exact_months <= 150) {
      if (age_exact_months > 100 && age_exact_months <= 101) {
        if (gender === 'F') {
          Weightmax = 32.88532;
        } else if ( gender === 'M') {
          Weightmax = 32.16804;
        } 
      } else if (age_exact_months > 101 && age_exact_months <= 102) {
        if (gender === 'F') {
          Weightmax = 33.26144;
        } else if ( gender === 'M') {
          Weightmax = 32.49452;
        } 
      } else if (age_exact_months > 102 && age_exact_months <= 103) {
        if (gender === 'F') {
          Weightmax = 33.64269;
        } else if ( gender === 'M') {
          Weightmax = 32.82526;
        } 
      } else if (age_exact_months > 103 && age_exact_months <= 104) {
        if (gender === 'F') {
          Weightmax = 34.02905;
        } else if ( gender === 'M') {
          Weightmax = 33.16038;
        } 
      } else if (age_exact_months > 104 && age_exact_months <= 105) {
        if (gender === 'F') {
          Weightmax = 34.42050;
        } else if ( gender === 'M') {
          Weightmax = 33.49994;
        } 
      } else if (age_exact_months > 105 && age_exact_months <= 106) {
        if (gender === 'F') {
          Weightmax = 34.81701;
        } else if ( gender === 'M') {
          Weightmax = 33.84402;
        } 
      } else if (age_exact_months > 106 && age_exact_months <= 107) {
        if (gender === 'F') {
          Weightmax = 35.21854;
        } else if ( gender === 'M') {
          Weightmax = 34.19269;
        } 
      } else if (age_exact_months > 107 && age_exact_months <= 108) {
        if (gender === 'F') {
          Weightmax = 35.62504;
        } else if ( gender === 'M') {
          Weightmax = 34.54602;
        } 
      } else if (age_exact_months > 108 && age_exact_months <= 109) {
        if (gender === 'F') {
          Weightmax = 36.03642;
        } else if ( gender === 'M') {
          Weightmax = 34.90407;
        } 
      } else if (age_exact_months > 109 && age_exact_months <= 110) {
        if (gender === 'F') {
          Weightmax = 36.45262;
        } else if ( gender === 'M') {
          Weightmax = 35.26687;
        } 
      } else if (age_exact_months > 110 && age_exact_months <= 111) {
        if (gender === 'F') {
          Weightmax = 36.87354;
        } else if ( gender === 'M') {
          Weightmax = 35.63448;
        } 
      } else if (age_exact_months > 111 && age_exact_months <= 112) {
        if (gender === 'F') {
          Weightmax = 37.29908;
        } else if ( gender === 'M') {
          Weightmax = 36.00693;
        } 
      } else if (age_exact_months > 112 && age_exact_months <= 113) {
        if (gender === 'F') {
          Weightmax = 37.72912;
        } else if ( gender === 'M') {
          Weightmax = 36.38425;
        } 
      } else if (age_exact_months > 113 && age_exact_months <= 114) {
        if (gender === 'F') {
          Weightmax = 38.16354;
        } else if ( gender === 'M') {
          Weightmax = 36.76647;
        } 
      } else if (age_exact_months > 114 && age_exact_months <= 115) {
        if (gender === 'F') {
          Weightmax = 38.60218;
        } else if ( gender === 'M') {
          Weightmax = 37.15359;
        } 
      } else if (age_exact_months > 115 && age_exact_months <= 116) {
        if (gender === 'F') {
          Weightmax = 39.04491;
        } else if ( gender === 'M') {
          Weightmax = 37.54563;
        } 
      } else if (age_exact_months > 116 && age_exact_months <= 117) {
        if (gender === 'F') {
          Weightmax = 39.49156;
        } else if ( gender === 'M') {
          Weightmax = 37.94259;
        } 
      } else if (age_exact_months > 117 && age_exact_months <= 118) {
        if (gender === 'F') {
          Weightmax = 39.94194;
        } else if ( gender === 'M') {
          Weightmax = 38.34446;
        } 
      } else if (age_exact_months > 118 && age_exact_months <= 119) {
        if (gender === 'F') {
          Weightmax = 40.39588;
        } else if ( gender === 'M') {
          Weightmax = 38.75124;
        } 
      } else if (age_exact_months > 119 && age_exact_months <= 120) {
        if (gender === 'F') {
          Weightmax = 40.85318;
        } else if ( gender === 'M') {
          Weightmax = 39.16289;
        } 
      } else if (age_exact_months > 120 && age_exact_months <= 121) {
        if (gender === 'F') {
          Weightmax = 41.31364;
        } else if ( gender === 'M') {
          Weightmax = 39.57940;
        } 
      } else if (age_exact_months > 121 && age_exact_months <= 122) {
        if (gender === 'F') {
          Weightmax = 41.77702;
        } else if ( gender === 'M') {
          Weightmax = 40.00073;
        } 
      } else if (age_exact_months > 122 && age_exact_months <= 123) {
        if (gender === 'F') {
          Weightmax = 42.24311;
        } else if ( gender === 'M') {
          Weightmax = 40.42684;
        } 
      } else if (age_exact_months > 123 && age_exact_months <= 124) {
        if (gender === 'F') {
          Weightmax = 42.71167;
        } else if ( gender === 'M') {
          Weightmax = 40.85769;
        } 
      } else if (age_exact_months > 124 && age_exact_months <= 125) {
        if (gender === 'F') {
          Weightmax = 43.18244;
        } else if ( gender === 'M') {
          Weightmax = 41.29322;
        } 
      } else if (age_exact_months > 125 && age_exact_months <= 126) {
        if (gender === 'F') {
          Weightmax = 43.65518;
        } else if ( gender === 'M') {
          Weightmax = 41.73338;
        } 
      } else if (age_exact_months > 126 && age_exact_months <= 127) {
        if (gender === 'F') {
          Weightmax = 44.12962;
        } else if ( gender === 'M') {
          Weightmax = 42.17809;
        } 
      } else if (age_exact_months > 127 && age_exact_months <= 128) {
        if (gender === 'F') {
          Weightmax = 44.60550;
        } else if ( gender === 'M') {
          Weightmax = 42.62729;
        } 
      } else if (age_exact_months > 128 && age_exact_months <= 129) {
        if (gender === 'F') {
          Weightmax = 45.08252;
        } else if ( gender === 'M') {
          Weightmax = 43.08089;
        } 
      } else if (age_exact_months > 129 && age_exact_months <= 130) {
        if (gender === 'F') {
          Weightmax = 45.56040;
        } else if ( gender === 'M') {
          Weightmax = 43.53882;
        } 
      } else if (age_exact_months > 130 && age_exact_months <= 131) {
        if (gender === 'F') {
          Weightmax = 46.03885;
        } else if ( gender === 'M') {
          Weightmax = 44.00097;
        } 
      } else if (age_exact_months > 131 && age_exact_months <= 132) {
        if (gender === 'F') {
          Weightmax = 46.51759;
        } else if ( gender === 'M') {
          Weightmax = 44.46726;
        } 
      } else if (age_exact_months > 132 && age_exact_months <= 133) {
        if (gender === 'F') {
          Weightmax = 46.99629;
        } else if ( gender === 'M') {
          Weightmax = 44.93758;
        } 
      } else if (age_exact_months > 133 && age_exact_months <= 134) {
        if (gender === 'F') {
          Weightmax = 47.47466;
        } else if ( gender === 'M') {
          Weightmax = 45.41182;
        } 
      } else if (age_exact_months > 134 && age_exact_months <= 135) {
        if (gender === 'F') {
          Weightmax = 47.95238;
        } else if ( gender === 'M') {
          Weightmax = 45.88986;
        } 
      } else if (age_exact_months > 135 && age_exact_months <= 136) {
        if (gender === 'F') {
          Weightmax = 48.42915;
        } else if ( gender === 'M') {
          Weightmax = 46.37159;
        } 
      } else if (age_exact_months > 136 && age_exact_months <= 137) {
        if (gender === 'F') {
          Weightmax = 48.90464;
        } else if ( gender === 'M') {
          Weightmax = 46.85689;
        } 
      } else if (age_exact_months > 137 && age_exact_months <= 138) {
        if (gender === 'F') {
          Weightmax = 49.37853;
        } else if ( gender === 'M') {
          Weightmax = 47.34561;
        } 
      } else if (age_exact_months > 138 && age_exact_months <= 139) {
        if (gender === 'F') {
          Weightmax = 49.85051;
        } else if ( gender === 'M') {
          Weightmax = 47.83762;
        } 
      } else if (age_exact_months > 139 && age_exact_months <= 140) {
        if (gender === 'F') {
          Weightmax = 50.32026;
        } else if ( gender === 'M') {
          Weightmax = 48.33279;
        } 
      } else if (age_exact_months > 140 && age_exact_months <= 141) {
        if (gender === 'F') {
          Weightmax = 50.78746;
        } else if ( gender === 'M') {
          Weightmax = 48.83097;
        } 
      } else if (age_exact_months > 141 && age_exact_months <= 142) {
        if (gender === 'F') {
          Weightmax = 51.25178;
        } else if ( gender === 'M') {
          Weightmax = 49.33200;
        } 
      } else if (age_exact_months > 142 && age_exact_months <= 143) {
        if (gender === 'F') {
          Weightmax = 51.71292;
        } else if ( gender === 'M') {
          Weightmax = 49.83573;
        } 
      } else if (age_exact_months > 143 && age_exact_months <= 144) {
        if (gender === 'F') {
          Weightmax = 52.17055;
        } else if ( gender === 'M') {
          Weightmax = 50.34200;
        } 
      } else if (age_exact_months > 144 && age_exact_months <= 145) {
        if (gender === 'F') {
          Weightmax = 52.62436;
        } else if ( gender === 'M') {
          Weightmax = 50.85064;
        } 
      } else if (age_exact_months > 145 && age_exact_months <= 146) {
        if (gender === 'F') {
          Weightmax = 53.07406;
        } else if ( gender === 'M') {
          Weightmax = 51.36149;
        } 
      } else if (age_exact_months > 146 && age_exact_months <= 147) {
        if (gender === 'F') {
          Weightmax = 53.51933;
        } else if ( gender === 'M') {
          Weightmax = 51.87437;
        } 
      } else if (age_exact_months > 147 && age_exact_months <= 148) {
        if (gender === 'F') {
          Weightmax = 53.95987;
        } else if ( gender === 'M') {
          Weightmax = 52.38910;
        } 
      } else if (age_exact_months > 148 && age_exact_months <= 149) {
        if (gender === 'F') {
          Weightmax = 54.39540;
        } else if ( gender === 'M') {
          Weightmax = 52.90551;
        } 
      } else if (age_exact_months > 149 && age_exact_months <= 150) {
        if (gender === 'F') {
          Weightmax = 54.82562;
        } else if ( gender === 'M') {
          Weightmax = 53.42340;
        } 
      }
    }
    if (age_exact_months > 150 && age_exact_months <= 200) {
      if (age_exact_months > 150 && age_exact_months <= 151) {
        if (gender === 'F') {
          Weightmax = 55.25027;
        } else if ( gender === 'M') {
          Weightmax = 53.94259;
        } 
      } else if (age_exact_months > 151 && age_exact_months <= 152) {
        if (gender === 'F') {
          Weightmax = 55.66906;
        } else if ( gender === 'M') {
          Weightmax = 54.46289;
        } 
      } else if (age_exact_months > 152 && age_exact_months <= 153) {
        if (gender === 'F') {
          Weightmax = 56.08174;
        } else if ( gender === 'M') {
          Weightmax = 54.98410;
        } 
      } else if (age_exact_months > 153 && age_exact_months <= 154) {
        if (gender === 'F') {
          Weightmax = 56.48806;
        } else if ( gender === 'M') {
          Weightmax = 55.50601;
        } 
      } else if (age_exact_months > 154 && age_exact_months <= 155) {
        if (gender === 'F') {
          Weightmax = 56.88777;
        } else if ( gender === 'M') {
          Weightmax = 56.02843;
        } 
      } else if (age_exact_months > 155 && age_exact_months <= 156) {
        if (gender === 'F') {
          Weightmax = 57.28064;
        } else if ( gender === 'M') {
          Weightmax = 56.55115;
        } 
      } else if (age_exact_months > 156 && age_exact_months <= 157) {
        if (gender === 'F') {
          Weightmax = 57.66646;
        } else if ( gender === 'M') {
          Weightmax = 57.07397;
        } 
      } else if (age_exact_months > 157 && age_exact_months <= 158) {
        if (gender === 'F') {
          Weightmax = 58.04501;
        } else if ( gender === 'M') {
          Weightmax = 57.59667;
        } 
      } else if (age_exact_months > 158 && age_exact_months <= 159) {
        if (gender === 'F') {
          Weightmax = 58.41609;
        } else if ( gender === 'M') {
          Weightmax = 58.11903;
        } 
      } else if (age_exact_months > 159 && age_exact_months <= 160) {
        if (gender === 'F') {
          Weightmax = 58.77954;
        } else if ( gender === 'M') {
          Weightmax = 58.64085;
        } 
      } else if (age_exact_months > 160 && age_exact_months <= 161) {
        if (gender === 'F') {
          Weightmax = 59.13517;
        } else if ( gender === 'M') {
          Weightmax = 59.16190;
        } 
      } else if (age_exact_months > 161 && age_exact_months <= 162) {
        if (gender === 'F') {
          Weightmax = 59.48284;
        } else if ( gender === 'M') {
          Weightmax = 59.68196;
        } 
      } else if (age_exact_months > 162 && age_exact_months <= 163) {
        if (gender === 'F') {
          Weightmax = 59.82240;
        } else if ( gender === 'M') {
          Weightmax = 60.20081;
        } 
      } else if (age_exact_months > 163 && age_exact_months <= 164) {
        if (gender === 'F') {
          Weightmax = 60.15373;
        } else if ( gender === 'M') {
          Weightmax = 60.71822;
        } 
      } else if (age_exact_months > 164 && age_exact_months <= 165) {
        if (gender === 'F') {
          Weightmax = 60.47673;
        } else if ( gender === 'M') {
          Weightmax = 61.23397;
        } 
      } else if (age_exact_months > 165 && age_exact_months <= 166) {
        if (gender === 'F') {
          Weightmax = 60.79129;
        } else if ( gender === 'M') {
          Weightmax = 61.74783;
        } 
      } else if (age_exact_months > 166 && age_exact_months <= 167) {
        if (gender === 'F') {
          Weightmax = 61.09735;
        } else if ( gender === 'M') {
          Weightmax = 62.25957;
        } 
      } else if (age_exact_months > 167 && age_exact_months <= 168) {
        if (gender === 'F') {
          Weightmax = 61.39485;
        } else if ( gender === 'M') {
          Weightmax = 62.76896;
        } 
      } else if (age_exact_months > 168 && age_exact_months <= 169) {
        if (gender === 'F') {
          Weightmax = 61.68375;
        } else if ( gender === 'M') {
          Weightmax = 63.27577;
        } 
      } else if (age_exact_months > 169 && age_exact_months <= 170) {
        if (gender === 'F') {
          Weightmax = 61.96402;
        } else if ( gender === 'M') {
          Weightmax = 63.77978;
        } 
      } else if (age_exact_months > 170 && age_exact_months <= 171) {
        if (gender === 'F') {
          Weightmax = 62.23565;
        } else if ( gender === 'M') {
          Weightmax = 64.28074;
        } 
      } else if (age_exact_months > 171 && age_exact_months <= 172) {
        if (gender === 'F') {
          Weightmax = 62.49867;
        } else if ( gender === 'M') {
          Weightmax = 64.77843;
        } 
      } else if (age_exact_months > 172 && age_exact_months <= 173) {
        if (gender === 'F') {
          Weightmax = 62.75310;
        } else if ( gender === 'M') {
          Weightmax = 65.27261;
        } 
      } else if (age_exact_months > 173 && age_exact_months <= 174) {
        if (gender === 'F') {
          Weightmax = 62.99899;
        } else if ( gender === 'M') {
          Weightmax = 65.76307;
        } 
      } else if (age_exact_months > 174 && age_exact_months <= 175) {
        if (gender === 'F') {
          Weightmax = 63.23641;
        } else if ( gender === 'M') {
          Weightmax = 66.24956;
        } 
      } else if (age_exact_months > 175 && age_exact_months <= 176) {
        if (gender === 'F') {
          Weightmax = 63.46545;
        } else if ( gender === 'M') {
          Weightmax = 66.73187;
        } 
      } else if (age_exact_months > 176 && age_exact_months <= 177) {
        if (gender === 'F') {
          Weightmax = 63.86821;
        } else if ( gender === 'M') {
          Weightmax = 67.20977;
        } 
      } else if (age_exact_months > 177 && age_exact_months <= 178) {
        if (gender === 'F') {
          Weightmax = 63.89881;
        } else if ( gender === 'M') {
          Weightmax = 67.68304;
        } 
      } else if (age_exact_months > 178 && age_exact_months <= 179) {
        if (gender === 'F') {
          Weightmax = 64.10339;
        } else if ( gender === 'M') {
          Weightmax = 68.15146;
        } 
      } else if (age_exact_months > 179 && age_exact_months <= 180) {
        if (gender === 'F') {
          Weightmax = 64.30012;
        } else if ( gender === 'M') {
          Weightmax = 68.61480;
        } 
      } else if (age_exact_months > 180 && age_exact_months <= 181) {
        if (gender === 'F') {
          Weightmax = 64.48917;
        } else if ( gender === 'M') {
          Weightmax = 69.07287;
        } 
      } else if (age_exact_months > 181 && age_exact_months <= 182) {
        if (gender === 'F') {
          Weightmax = 64.67073;
        } else if ( gender === 'M') {
          Weightmax = 69.52547;
        } 
      } else if (age_exact_months > 182 && age_exact_months <= 183) {
        if (gender === 'F') {
          Weightmax = 64.84502;
        } else if ( gender === 'M') {
          Weightmax = 69.97237;
        } 
      } else if (age_exact_months > 183 && age_exact_months <= 184) {
        if (gender === 'F') {
          Weightmax = 65.01225;
        } else if ( gender === 'M') {
          Weightmax = 70.41340;
        } 
      } else if (age_exact_months > 184 && age_exact_months <= 185) {
        if (gender === 'F') {
          Weightmax = 65.17268;
        } else if ( gender === 'M') {
          Weightmax = 70.84837;
        } 
      } else if (age_exact_months > 185 && age_exact_months <= 186) {
        if (gender === 'F') {
          Weightmax = 65.32655;
        } else if ( gender === 'M') {
          Weightmax = 71.27708;
        } 
      } else if (age_exact_months > 186 && age_exact_months <= 187) {
        if (gender === 'F') {
          Weightmax = 65.47414;
        } else if ( gender === 'M') {
          Weightmax = 71.69938;
        } 
      } else if (age_exact_months > 187 && age_exact_months <= 188) {
        if (gender === 'F') {
          Weightmax = 65.61573;
        } else if ( gender === 'M') {
          Weightmax = 72.11508;
        } 
      } else if (age_exact_months > 188 && age_exact_months <= 189) {
        if (gender === 'F') {
          Weightmax = 65.75161;
        } else if ( gender === 'M') {
          Weightmax = 72.52404;
        } 
      } else if (age_exact_months > 189 && age_exact_months <= 190) {
        if (gender === 'F') {
          Weightmax = 65.88209;
        } else if ( gender === 'M') {
          Weightmax = 72.92611;
        } 
      } else if (age_exact_months > 190 && age_exact_months <= 191) {
        if (gender === 'F') {
          Weightmax = 66.00750;
        } else if ( gender === 'M') {
          Weightmax = 73.32115;
        } 
      } else if (age_exact_months > 191 && age_exact_months <= 192) {
        if (gender === 'F') {
          Weightmax = 66.12815;
        } else if ( gender === 'M') {
          Weightmax = 73.70903;
        } 
      } else if (age_exact_months > 192 && age_exact_months <= 193) {
        if (gender === 'F') {
          Weightmax = 66.24437;
        } else if ( gender === 'M') {
          Weightmax = 74.08963;
        } 
      } else if (age_exact_months > 193 && age_exact_months <= 194) {
        if (gender === 'F') {
          Weightmax = 66.35652;
        } else if ( gender === 'M') {
          Weightmax = 74.46286;
        } 
      } else if (age_exact_months > 194 && age_exact_months <= 195) {
        if (gender === 'F') {
          Weightmax = 66.46493;
        } else if ( gender === 'M') {
          Weightmax = 74.82861;
        } 
      } else if (age_exact_months > 195 && age_exact_months <= 196) {
        if (gender === 'F') {
          Weightmax = 66.56995;
        } else if ( gender === 'M') {
          Weightmax = 75.18681;
        } 
      } else if (age_exact_months > 196 && age_exact_months <= 197) {
        if (gender === 'F') {
          Weightmax = 66.67195;
        } else if ( gender === 'M') {
          Weightmax = 75.53738;
        } 
      } else if (age_exact_months > 197 && age_exact_months <= 198) {
        if (gender === 'F') {
          Weightmax = 66.77126;
        } else if ( gender === 'M') {
          Weightmax = 75.88026;
        } 
      } else if (age_exact_months > 198 && age_exact_months <= 199) {
        if (gender === 'F') {
          Weightmax = 66.86826;
        } else if ( gender === 'M') {
          Weightmax = 76.21540;
        } 
      } else if (age_exact_months > 199 && age_exact_months <= 200) {
        if (gender === 'F') {
          Weightmax = 66.96328;
        } else if ( gender === 'M') {
          Weightmax = 76.54278;
        } 
      }
    }
    if (age_exact_months > 200) {
      if (age_exact_months > 200 && age_exact_months <= 201) {
        if (gender === 'F') {
          Weightmax = 67.05668;
        } else if ( gender === 'M') {
          Weightmax = 76.86237;
        } 
      } else if (age_exact_months > 201 && age_exact_months <= 202) {
        if (gender === 'F') {
          Weightmax = 67.14881;
        } else if ( gender === 'M') {
          Weightmax = 77.17417;
        } 
      } else if (age_exact_months > 202 && age_exact_months <= 203) {
        if (gender === 'F') {
          Weightmax = 67.24000;
        } else if ( gender === 'M') {
          Weightmax = 77.47817;
        } 
      } else if (age_exact_months > 203 && age_exact_months <= 204) {
        if (gender === 'F') {
          Weightmax = 67.33059;
        } else if ( gender === 'M') {
          Weightmax = 77.77440;
        } 
      } else if (age_exact_months > 204 && age_exact_months <= 205) {
        if (gender === 'F') {
          Weightmax = 67.42090;
        } else if ( gender === 'M') {
          Weightmax = 78.06288;
        } 
      } else if (age_exact_months > 205 && age_exact_months <= 206) {
        if (gender === 'F') {
          Weightmax = 67.51123;
        } else if ( gender === 'M') {
          Weightmax = 78.34366;
        } 
      } else if (age_exact_months > 206 && age_exact_months <= 207) {
        if (gender === 'F') {
          Weightmax = 67.60188;
        } else if ( gender === 'M') {
          Weightmax = 78.61679;
        } 
      } else if (age_exact_months > 207 && age_exact_months <= 208) {
        if (gender === 'F') {
          Weightmax = 67.69314;
        } else if ( gender === 'M') {
          Weightmax = 78.88236;
        } 
      } else if (age_exact_months > 208 && age_exact_months <= 209) {
        if (gender === 'F') {
          Weightmax = 67.78528;
        } else if ( gender === 'M') {
          Weightmax = 79.14043;
        } 
      } else if (age_exact_months > 209 && age_exact_months <= 210) {
        if (gender === 'F') {
          Weightmax = 67.87853;
        } else if ( gender === 'M') {
          Weightmax = 79.39110;
        } 
      } else if (age_exact_months > 210 && age_exact_months <= 211) {
        if (gender === 'F') {
          Weightmax = 67.97313;
        } else if ( gender === 'M') {
          Weightmax = 79.63450;
        } 
      } else if (age_exact_months > 211 && age_exact_months <= 212) {
        if (gender === 'F') {
          Weightmax = 68.06928;
        } else if ( gender === 'M') {
          Weightmax = 79.87074;
        } 
      } else if (age_exact_months > 212 && age_exact_months <= 213) {
        if (gender === 'F') {
          Weightmax = 68.16716;
        } else if ( gender === 'M') {
          Weightmax = 80.09998;
        } 
      } else if (age_exact_months > 213 && age_exact_months <= 214) {
        if (gender === 'F') {
          Weightmax = 68.26692;
        } else if ( gender === 'M') {
          Weightmax = 80.32236;
        } 
      } else if (age_exact_months > 214 && age_exact_months <= 215) {
        if (gender === 'F') {
          Weightmax = 68.36869;
        } else if ( gender === 'M') {
          Weightmax = 80.53806;
        } 
      } else if (age_exact_months > 215 && age_exact_months <= 216) {
        if (gender === 'F') {
          Weightmax = 68.47256;
        } else if ( gender === 'M') {
          Weightmax = 80.74727;
        } 
      } else if (age_exact_months > 216 && age_exact_months <= 217) {
        if (gender === 'F') {
          Weightmax = 68.57859;
        } else if ( gender === 'M') {
          Weightmax = 80.95019;
        } 
      } else if (age_exact_months > 217 && age_exact_months <= 218) {
        if (gender === 'F') {
          Weightmax = 68.68680;
        } else if ( gender === 'M') {
          Weightmax = 81.14704;
        } 
      } else if (age_exact_months > 218 && age_exact_months <= 219) {
        if (gender === 'F') {
          Weightmax = 68.79718;
        } else if ( gender === 'M') {
          Weightmax = 81.33806;
        } 
      } else if (age_exact_months > 219 && age_exact_months <= 220) {
        if (gender === 'F') {
          Weightmax = 68.90968;
        } else if ( gender === 'M') {
          Weightmax = 81.52350;
        } 
      } else if (age_exact_months > 220 && age_exact_months <= 221) {
        if (gender === 'F') {
          Weightmax = 69.02421;
        } else if ( gender === 'M') {
          Weightmax = 81.70364;
        } 
      } else if (age_exact_months > 221 && age_exact_months <= 222) {
        if (gender === 'F') {
          Weightmax = 69.14061;
        } else if ( gender === 'M') {
          Weightmax = 81.87876;
        } 
      } else if (age_exact_months > 222 && age_exact_months <= 223) {
        if (gender === 'F') {
          Weightmax = 69.25872;
        } else if ( gender === 'M') {
          Weightmax = 82.04917;
        } 
      } else if (age_exact_months > 223 && age_exact_months <= 224) {
        if (gender === 'F') {
          Weightmax = 69.37830;
        } else if ( gender === 'M') {
          Weightmax = 82.21519;
        } 
      } else if (age_exact_months > 224 && age_exact_months <= 225) {
        if (gender === 'F') {
          Weightmax = 69.49906;
        } else if ( gender === 'M') {
          Weightmax = 82.37714;
        } 
      } else if (age_exact_months > 225 && age_exact_months <= 226) {
        if (gender === 'F') {
          Weightmax = 69.62067;
        } else if ( gender === 'M') {
          Weightmax = 82.53537;
        } 
      } else if (age_exact_months > 226 && age_exact_months <= 227) {
        if (gender === 'F') {
          Weightmax = 69.74274;
        } else if ( gender === 'M') {
          Weightmax = 82.69026;
        } 
      } else if (age_exact_months > 227 && age_exact_months <= 228) {
        if (gender === 'F') {
          Weightmax = 69.86482;
        } else if ( gender === 'M') {
          Weightmax = 82.84218;
        } 
      } else if (age_exact_months > 228 && age_exact_months <= 229) {
        if (gender === 'F') {
          Weightmax = 69.98642;
        } else if ( gender === 'M') {
          Weightmax = 82.99151;
        } 
      } else if (age_exact_months > 229 && age_exact_months <= 230) {
        if (gender === 'F') {
          Weightmax = 70.10698;
        } else if ( gender === 'M') {
          Weightmax = 83.13866;
        } 
      } else if (age_exact_months > 230 && age_exact_months <= 231) {
        if (gender === 'F') {
          Weightmax = 70.22587;
        } else if ( gender === 'M') {
          Weightmax = 83.28402;
        } 
      } else if (age_exact_months > 231 && age_exact_months <= 232) {
        if (gender === 'F') {
          Weightmax = 70.34241;
        } else if ( gender === 'M') {
          Weightmax = 83.42802;
        } 
      } else if (age_exact_months > 232 && age_exact_months <= 233) {
        if (gender === 'F') {
          Weightmax = 70.45586;
        } else if ( gender === 'M') {
          Weightmax = 83.57106;
        } 
      } else if (age_exact_months > 233 && age_exact_months <= 234) {
        if (gender === 'F') {
          Weightmax = 70.56542;
        } else if ( gender === 'M') {
          Weightmax = 83.71357;
        } 
      } else if (age_exact_months > 234 && age_exact_months <= 235) {
        if (gender === 'F') {
          Weightmax = 70.67021;
        } else if ( gender === 'M') {
          Weightmax = 83.85596;
        } 
      } else if (age_exact_months > 235 && age_exact_months <= 236) {
        if (gender === 'F') {
          Weightmax = 70.76929;
        } else if ( gender === 'M') {
          Weightmax = 83.99867;
        } 
      } else if (age_exact_months > 236 && age_exact_months <= 237) {
        if (gender === 'F') {
          Weightmax = 70.86167;
        } else if ( gender === 'M') {
          Weightmax = 84.14210;
        } 
      } else if (age_exact_months > 237 && age_exact_months <= 238) {
        if (gender === 'F') {
          Weightmax = 70.94627;
        } else if ( gender === 'M') {
          Weightmax = 84.28667;
        } 
      } else if (age_exact_months > 238 && age_exact_months <= 239) {
        if (gender === 'F') {
          Weightmax = 71.02194;
        } else if ( gender === 'M') {
          Weightmax = 84.43280;
        } 
      } else if (age_exact_months > 239 && age_exact_months <= 240) {
        if (gender === 'F') {
          Weightmax = 71.08749;
        } else if ( gender === 'M') {
          Weightmax = 84.58088;
        } 
      } else if (age_exact_months > 240) {
        if (gender === 'F') {
          Weightmax = 71.11606;
        } else if ( gender === 'M') {
          Weightmax = 84.65578;
        } 
      } 
    }

    if (Weightmax !== "") {
      //var weight_number = weight.replace("kg", "");
      WriteToLog("Weightmax: " + Weightmax + " -- Patient weight: " + weight);
      if (weight > Weightmax) {
        overweightRisk = "yes";
      }
    }
    WriteToLog("Inside calculateOverweightRisk: " + overweightRisk);
    return overweightRisk;
  } catch (error) {
    if (error.response) {
      WriteToLog("calculateOverWeight error.response: " + JSON.stringify(error.response.status));
    } else if (error.request) {
      WriteToLog("calculateOverWeight error.request: " + error.request);
    } else {
      WriteToLog('calculateOverWeight Error ', error.message);
    }
    return overweightRisk;  
  }  
}

export default calculateOverWeight;
